<template>
  <div class="page-content">
    <div class="banner">
      <el-carousel height="100%" direction="vertical" :autoplay="!isPlaying">
        <el-carousel-item
          v-for="(item, idx) in imgs"
          :key="idx + 'img'"
          :label="'0' + (idx + 1)"
        >
          <video
            v-show="idx == 0"
            controls
            ref="video"
            :src="item"
            class="video"
            muted
            @play="handleVideoPlay"
            @pause="onVideoEnded"
            @ended="onVideoEnded"
          ></video>
          <img v-if="idx > 0" :src="require('../../assets/img/' + item)" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="desc">
      <!-- :class="{
          'slide-right': scrollHeight && isShow('desc-text', 'slide-right'),
        }" -->

      <!-- :class="{
          'desc-tips slide-top': scrollHeight && isShow('desc-tips', 'slide-top'),
        }" -->
      <div class="desc-text">
        <h2 class="font-blod">Compromiso con la BUENA Construcción</h2>
        <p class="">
          Nuestra finalidad es dar respuesta profesional a todos los procesos
        </p>
        <p class=""></p>
        <p class="">
          intervinientes en la construcción de un modo eficiente dando a los
        </p>
        <p class="">
          estudios de arquitectura e ingenierías un soporte tanto técnico
        </p>
        <p class="">
          como en obra con un exhaustivo control económico y de planificación.
        </p>
      </div>
      <div class="desc-tips">
        <b class="font-blod">MARAGON</b>
        nace de la unión de un<br />
        equipo de profesionales con<br />
        amplísima experiencia en el sector<br />
        de la construcción y ejecutando obras de toda índole con el objetivo de
        crear una empresa de alta calidad en obra y <br />
        servicio al cliente.
        <h1 class="font-blod">
          <p>EFICIENCIA</p>
          <p>EN</p>
          <p>CONSTRUCCIÓN</p>
        </h1>
      </div>
    </div>
    <div class="row-1">
      <img src="../../assets/img/home1.jpg" />
      <div
        class="row-1-text hide"
        :class="{
          'fade-in': scrollHeight && isShow('row-1-text', 'fade-in'),
        }"
      >
        <h1 class="font-blod">+400<small>Obras realizadas </small></h1>
        <h1 class="font-blod">+75.000m²<small>de obras realizadas </small></h1>
      </div>
    </div>
    <el-row class="grid">
      <el-col
        v-for="(item, idx) in list"
        :key="idx"
        :md="8"
        :xs="12"
        :span="8"
        class="grid-item hide"
        :class="{
          'fade-in': scrollHeight && isShow('grid-item', 'fade-in'),
        }"
        :style="{
          'animation-delay': idx * 0.5 + 's',
        }"
      >
        <div
          class="grid-item-body"
          :style="{
            'background-color': item.color || '',
          }"
          @click="openPage(idx)"
        >
          <img :src="require('../../assets/img/' + item.img)" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    scrollHeight: Number,
  },
  data() {
    return {
      isPlaying: false,
      imgs: [
        "/video/home-video.mp4",
        "home-banner2.jpg",
        "home-banner3.jpg",
        "home-banner1.jpg",
      ],
      list: [
        {
          img: "home2.svg",
          color: "#c5ba60",
          text: `VIVIENDAS<br/>UNIFAMILIARES<br/>EXCLUSIVAS`,
        },
        {
          img: "home3.svg",
          color: "#202b47",
          text: `PROMOCIONES Y<br/>OBRA EN ALTURA`,
        },
        {
          img: "home4.svg",
          color: "#e1e3de",
          textColor: "#000",
          text: `REFORMA <br/>INTEGRAL`,
        },
        {
          img: "home5.svg",
          color: "#97aae5",
          text: `OFICINAS,OCI<br/>OY RETAIL`,
        },
        {
          img: "home6.svg",
          color: "#000000",
          text: `CENTROS <br/>EDUCATIVOS <br/>Y DEPORTIVOS`,
        },
        {
          img: "home7.svg",
          color: "#50bac0",
          text: `OTRAS OBRAS`,
        },
      ],
    };
  },
  watch: {
    scrollHeight() {
      this.init();
    },
    isPlaying() {
      this.tipIsShow();
    },
  },
  mounted() {
    setTimeout(() => {
      this.init();
    
    this.$refs.video[0].play();
    }, 800);
  },
  methods: {
    init() {
      if (this.isShow(`desc-text`, "slide-right")) {
        document.querySelector(`.desc-text`).className =
          document
            .querySelector(`.desc-text`)
            .className.replace("slide-right", "") + " slide-right";
      }
      this.tipIsShow();
    },
    tipIsShow() {
      let dom = document.querySelector(`.desc-tips`);
      // 显示
      if (!this.isPlaying && this.isShow(`desc-tips`, "slide-top")) {
        if (dom.className.indexOf("slide-out") > -1) {
          dom.className = dom.className.replace("slide-out", "");
        }
        dom.className = dom.className.replace("slide-top", "") + " slide-top";
      } else if (dom.className.indexOf("slide-top") > -1) {
        //隐藏
        dom.className = dom.className.replace("slide-top", "slide-out");
      }
    },
    isShow(cls, a) {
      const l = document.querySelector("." + cls); //this.$refs[refName][idx]
      // const box = l.getBoundingClientRect();
      // console.log(box, this.scrollHeight,this.$utils.isElementInViewport(l));
      const isCls = l.className.indexOf(a) > -1;
      if (isCls) return true;
      return this.$utils.isElementInViewport(l);
    },
    openPage(idx) {
      this.$router.push({ path: `/obras?row=${idx}` });
    },
  
    handleVideoPlay() {
      this.isPlaying = true;
    },
    onVideoEnded() {
      this.isPlaying = false;
      // this.tipIsShow();
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  padding-top: 0px;

  .desc-tips {
    text-align: center;
    * {
      text-align: center;
    }
  }
  .banner {
    margin-top: 0px;
    height: calc(90vw * 0.5625);
    background: rgb(183, 183, 183);
    .el-carousel {
      width: 100%;
      height: 100%;
      &::v-deep img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .video {
        width: 100%;
        // height: 100%;/
        background-color: rgba(255, 255, 255, 1);
      }
    }
  }
  .row-1-text {
    animation-delay: 1s;
  }
}
.grid {
  .grid-item {
    // width: 33.33%;
  }
}
</style>
